/**
 * FiltersBar — строка поиска по комментарию/№ + фильтр по статусу + диапазон дат.
 * Фильтрация клиентская (см. PaymentsTable). Состояние поднято в PaymentsTab.
 */

import type { PaymentStatus } from '../../lib/types';
import { STATUS_META, STATUS_ORDER } from './lib/status';
import { IconSearch } from './ui/icons';

export interface PaymentFilters {
  q: string;
  status: PaymentStatus | 'ALL';
  from: string | null;
  to: string | null;
}

export const EMPTY_FILTERS: PaymentFilters = { q: '', status: 'ALL', from: null, to: null };

export interface FiltersBarProps {
  value: PaymentFilters;
  onChange: (next: PaymentFilters) => void;
}

export function FiltersBar({ value, onChange }: FiltersBarProps): JSX.Element {
  const dirty = value.q !== '' || value.status !== 'ALL' || value.from !== null || value.to !== null;

  return (
    <div className="pw-filters" role="search">
      <span className="pw-filters__search">
        <span className="pw-filters__search-icon" aria-hidden>
          <IconSearch size={15} />
        </span>
        <input
          type="search"
          className="pw-input pw-filters__search-input"
          placeholder="Поиск по № или комментарию"
          value={value.q}
          aria-label="Поиск платежей"
          onChange={(e) => onChange({ ...value, q: e.target.value })}
        />
      </span>

      <select
        className="pw-input pw-filters__status"
        value={value.status}
        aria-label="Фильтр по статусу"
        onChange={(e) => onChange({ ...value, status: e.target.value as PaymentFilters['status'] })}
      >
        <option value="ALL">Все статусы</option>
        {STATUS_ORDER.map((s) => (
          <option key={s} value={s}>
            {STATUS_META[s].label}
          </option>
        ))}
      </select>

      <span className="pw-filters__dates">
        <input
          type="date"
          className="pw-input pw-filters__date"
          value={value.from ?? ''}
          aria-label="Дата с"
          onChange={(e) => onChange({ ...value, from: e.target.value || null })}
        />
        <span className="pw-filters__dash" aria-hidden>
          —
        </span>
        <input
          type="date"
          className="pw-input pw-filters__date"
          value={value.to ?? ''}
          aria-label="Дата по"
          onChange={(e) => onChange({ ...value, to: e.target.value || null })}
        />
      </span>

      {dirty ? (
        <button type="button" className="pw-filters__reset" onClick={() => onChange(EMPTY_FILTERS)}>
          Сбросить
        </button>
      ) : null}
    </div>
  );
}
